const { createContext } = require("react");

const CategoriesContext = createContext();

export default CategoriesContext;
